<template>
  <v-col md="6" sm="12" class="border-right">
    <v-row>
      <v-col md="6" sm="12">
        <h2 class="text-xl">Online Payments</h2>
      </v-col>
      <v-col md="6" sm="12">
        <date-period
            :dense="true"
            :dateType="dateToggle"
            :dateDiff="5"
            @periodChange="dateChange"
        ></date-period>
      </v-col>
    </v-row>
    <div style="max-height: 400px; overflow-y: auto;">
      <v-simple-table class="table table-bordered table-responsive">
        <thead>
        <tr>
          <th class="text-center">Date</th>
          <th class="text-center">Started</th>
          <th class="text-center">Open</th>
          <th class="text-center">Successful</th>
          <th class="text-center">Failed</th>
          <th class="text-center">Refunds</th>
        </tr>
        </thead>
        <tbody>
        <!-- Show loader when loading -->
        <tr v-if="loading" class="text-center">
          <td colspan="6">
            <v-progress-circular
                indeterminate
                color="primary"
                size="40"
            ></v-progress-circular>
          </td>
        </tr>
        <!-- Show data when not loading -->
        <tr v-else-if="transactions.length > 0" v-for="(transaction,index) in transactions" class="text-center" :key="index">
          <td>{{ transaction.transaction_date | dateformat }}</td>
          <td>{{ transaction.total_count }}</td>
          <td>{{ transaction.open_count }}</td>
          <td>{{ transaction.successful_count }}</td>
          <td>{{ transaction.failed_count }}</td>
          <td>{{ transaction.refund_count }}</td>
        </tr>
        <tr v-else>
          <td colspan="6" class="text-center">
            <span>No records found</span>
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </div>
  </v-col>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      date1: moment().subtract(5, "days").format("YYYY-MM-DD"),
      date2: moment().format("YYYY-MM-DD"),
      dateToggle: "DATE",
      loading: false, // Loader state
      transactions:[
        {
          failed_count:0,
          open_count:0,
          refund_count:0,
          successful_count:0,
          total_count:0,
          transaction_date:'-',
        }
      ],
      fetchInterval:null,
    };
  },
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    this.stopAutoFetch();
  },
  methods: {
    startAutoFetch() {
      if(!this.fetchInterval){
        this.fetchInterval = setInterval(() => {
          this.getData(); // Fetch every 3 seconds
        }, 120000); // 3000ms = 3 seconds
      }
    },
    stopAutoFetch() {
      if (this.fetchInterval) {
        clearInterval(this.fetchInterval); // Clears the interval
        this.fetchInterval = null; // Reset the interval ID
      }
    },
    dateChange(data) {
      this.date1 = data.date1;
      this.date2 = data.date2;
      this.getData();
    },
    getData() {
      this.loading = true; // Start loader
      let url = `?mode=${this.dateToggle}&from_date=${this.date1}&to_date=${this.date2}`;

      this.$http
          .get(`monitoring/online-payments${url}`)
          .then((response) => {
            if (response.status == 200) {
              this.transactions = response.data.data;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          })
          .finally(() => {
            this.loading = false; // Stop loader
            this.startAutoFetch();
          });
    },
  },
};
</script>
